import { massagePayAnyoneGetResponse } from './massagePayAnyoneGetResponse';

export function fetchPayAnyoneShowResponse(
  graphqlData: { unauthenticated: { p2p: { pay_anyone: any } } },
  graphqlError: any,
  graphqlLoading: boolean,
  refetch?: () => void
) {
  const payAnyoneData = graphqlData?.unauthenticated?.p2p?.pay_anyone;

  switch (payAnyoneData?.__typename) {
    case 'PayAnyoneWithExternalCard':
      return {
        data: massagePayAnyoneGetResponse(graphqlData),
        error: graphqlError,
        isLoading: graphqlLoading,
        isError: !!graphqlError,
        refetch,
      };
    case 'PayAnyoneFetchError':
      return {
        data: payAnyoneData,
        error: graphqlError,
        isLoading: graphqlLoading,
        isError: true,
        refetch,
      };
    case 'StepUpRequiredError':
      return {
        data: payAnyoneData,
        error: graphqlError,
        isLoading: graphqlLoading,
        isError: true,
        refetch,
      };
    default:
      //eslint-disable-next-line no-console
      console.log('Received unexpected type:', payAnyoneData?.__typename);
      return {
        data: graphqlData,
        error: graphqlError,
        isLoading: graphqlLoading,
        isError: !!graphqlError,
        refetch,
      };
  }
}
